import React from "react";

// Create a context with default values
const MyContext = React.createContext({
  //Authentication
  headers: "",
  requestAuthentication: false,

  //Dev or Production
  dev: false,

  //Data
  data: {},

  //Laminin
  lamininSubmitted: false,
  lamininSent: false,
  lamininError: false,
  lamininResponse: "",

  //Forms
  personalInfoCaptured: false,
});

export default MyContext;
